var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-center",attrs:{"id":"empty_data"}},[_c('span',[_vm._v(_vm._s(_vm.dataTp)+"이 없습니다.")]),(_vm.desc)?_c('span',[_vm._v(_vm._s(_vm.desc))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }